export const PhoneFilterModule = angular
    .module('app.filters.phoneFilter', [])
    .filter('phone', () => {
        return (input) => {
            if (input === undefined || input === '') {
                return input;
            }
            input = input.replace(/[^\d]+/g, '');

            var country;
            var city;
            var number;

            switch (input.length) {
                case 10: // +1PPP####### -> C (PPP) ###-####
                    country = 1;
                    city = input.slice(0, 3);
                    number = input.slice(3);
                    break;

                case 11: // +CPPP####### -> CCC (PP) ###-####
                    country = input[0];
                    city = input.slice(1, 4);
                    number = input.slice(4);
                    break;

                case 12: // +CCCPP####### -> CCC (PP) ###-####
                    country = input.slice(0, 3);
                    city = input.slice(3, 5);
                    number = input.slice(5);
                    break;

                default:
                    return input;
            }

            if (country === 1) {
                country = '';
            }

            number = `${number.slice(0, 3)}-${number.slice(3)}`;

            return (`${country} (${city}) ${number}`).trim();
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/filters/phone.filter.js